module.exports = __webpack_public_path__ + "static/media/shrek-dab.761c33d2.gif";